import * as React from "react";
import {
    Select,
    SelectTrigger,
    SelectValue,
    SelectContent,
    SelectItem,
    SelectScrollUpButton,
    SelectScrollDownButton,
} from '../../../../components/ui/select'
import { Check } from "lucide-react";
import { SunbedItem } from "../../../../services/sunbeds";

interface SunbedSelectorProps {
    sunbeds: SunbedItem[];
    selected: SunbedItem[];
    onToggle: (sunbed: SunbedItem) => void;
}

export default function SunbedSelector({ sunbeds, selected, onToggle }: SunbedSelectorProps) {
    if (sunbeds.length === 0)
        return <p className="text-xs text-gray-400 italic">No sunbeds available.</p>;

    return (
        <div className="space-y-1">
            {/* Selected sunbeds as badges */}
            {selected.length > 0 && (
                <div className="flex flex-wrap gap-1 mb-1">
                    {selected.map((s) => (
                        <div
                            key={s.id}
                            className="flex items-center gap-1 bg-purple-100 text-purple-700 px-2 py-0.5 rounded-full text-[10px]"
                        >
                            <span>{s.label}</span>
                            <button
                                onClick={() => onToggle(s)}
                                className="text-purple-600 hover:text-purple-800"
                            >
                                ✕
                            </button>
                        </div>
                    ))}
                </div>
            )}
            <Select
                value=""
                onValueChange={(val) => {
                    const sunbed = sunbeds.find((s) => s.id === Number(val));
                    if (sunbed) onToggle(sunbed);
                }}
            >
                <SelectTrigger className="w-full h-8 text-xs mt-4">
                    <SelectValue placeholder="Select a sunbed" />
                </SelectTrigger>

                <SelectContent className="bg-white max-h-44">
                    {sunbeds.map((s) => {
                        const isSelected = selected.some((sel) => sel.id === s.id);
                        return (
                            <SelectItem key={s.id} value={String(s.id)}>
                                <div className="flex justify-between items-center text-xs">
                                    <span>{s.label}</span>
                                    {isSelected && <Check className="w-3 h-3 text-purple-700" />}
                                </div>
                            </SelectItem>
                        );
                    })}
                    <SelectScrollUpButton />
                    <SelectScrollDownButton />
                </SelectContent>
            </Select>
        </div>
    );
}
